import { useEffect, useState } from 'react';
import { DEBOUNCE_DELAY } from '@/_constants/common';

type TProps<TValue> = {
  value: TValue;
  delay?: number;
};

export const useDebounceValue = <TValue>({
  value,
  delay = DEBOUNCE_DELAY,
}: TProps<TValue>): TValue => {
  const [debouncedValue, setDebouncedValue] = useState<TValue>(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
};
